/* NgRx */
import { createAction, props } from "@ngrx/store";
import { Filter } from "../../../../models/filter";
import {
  FetchSessionResourcesModel
} from "../models/fetch-session-resources.model";
import {
  UpdateSessionDetailsModel
} from "../models/update-session-details.model";
import { FetchSessionDetailsModel } from "../models/fetch-session-details.model";
import { FetchSessionListModel } from "../models/fetch-session-list.model";
import {
  FetchParticipantAttendanceModel
} from "../models/fetch-participant-attendance.model";


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[sessions list] clear state';
export const ClearState = createAction(CLEAR_STATE);

/*********** FETCH SESSION DELIVERY FILTER **************/
const FETCH_SESSION_DELIVERY_FILTER_REQUEST = '[sessions list] fetch session delivery filter requested';
export const FetchSessionDeliveryFilterRequest = createAction(FETCH_SESSION_DELIVERY_FILTER_REQUEST);

const FETCH_SESSION_DELIVERY_FILTER_SUCCESS = '[sessions list] fetch session delivery filter successful';
export const FetchSessionDeliveryFilterSuccess = createAction(FETCH_SESSION_DELIVERY_FILTER_SUCCESS, props<{
  sessionDeliveryFilter: Filter,
  message: string
}>());

const FETCH_SESSION_DELIVERY_FILTER_FAILURE = '[sessions list] fetch session delivery filter failure';
export const FetchSessionDeliveryFilterFailure = createAction(FETCH_SESSION_DELIVERY_FILTER_FAILURE, props<{
  message: string
}>());

/*********** FETCH SESSION RESOURCES **************/
const FETCH_SESSION_RESOURCES_REQUEST = '[sessions list] fetch session resources requested';
export const FetchSessionResourcesRequest = createAction(FETCH_SESSION_RESOURCES_REQUEST, props<{
  payload?: FetchSessionResourcesModel['request']
}>());

const FETCH_SESSION_RESOURCES_SUCCESS = '[sessions list] fetch session resources successful';
export const FetchSessionResourcesSuccess = createAction(FETCH_SESSION_RESOURCES_SUCCESS, props<{
  data: FetchSessionResourcesModel['response']['data'],
  message: string
}>());

const FETCH_SESSION_RESOURCES_FAILURE = '[sessions list] fetch session resources failure';
export const FetchSessionResourcesFailure = createAction(FETCH_SESSION_RESOURCES_FAILURE);

/*********** UPDATE SESSION DETAILS **************/
const UPDATE_SESSION_DETAILS_REQUEST = '[sessions list] update session details requested';
export const UpdateSessionDetailsRequest = createAction(UPDATE_SESSION_DETAILS_REQUEST, props<{
  payload?: UpdateSessionDetailsModel['request'],
  isSessionList?: boolean
}>());

const UPDATE_SESSION_DETAILS_SUCCESS = '[sessions list] update session details successful';
export const UpdateSessionDetailsSuccess = createAction(UPDATE_SESSION_DETAILS_SUCCESS, props<{
  sessionDetails: UpdateSessionDetailsModel['response'],
  message: string
}>());

const UPDATE_SESSION_DETAILS_FAILURE = '[sessions list] update session details failure';
export const UpdateSessionDetailsFailure = createAction(UPDATE_SESSION_DETAILS_FAILURE);

/*********** FETCH SESSION DETAILS **************/
const FETCH_SESSION_DETAILS_REQUEST = '[sessions list] fetch session details requested';
export const FetchSessionDetailsRequest = createAction(FETCH_SESSION_DETAILS_REQUEST, props<{
  payload: FetchSessionDetailsModel['request'],
}>());

const FETCH_SESSION_DETAILS_SUCCESS = '[sessions list] fetch session details successful';
export const FetchSessionDetailsSuccess = createAction(FETCH_SESSION_DETAILS_SUCCESS, props<{
  sessionDetails: FetchSessionDetailsModel['response'],
  message: string
}>());

const FETCH_SESSION_DETAILS_FAILURE = '[sessions list] fetch session details failure';
export const FetchSessionDetailsFailure = createAction(FETCH_SESSION_DETAILS_FAILURE);

/******** FETCH COACHES FILTER ***********/

const FETCH_COACHES_FILTER_REQUEST = '[sessions list] fetch coaches filter requested';
export const FetchCoachesFilterRequest = createAction(FETCH_COACHES_FILTER_REQUEST, props<{payload?: {clientId?: number}}>());

const FETCH_COACHES_FILTER_SUCCESS = '[sessions list] fetch coaches filter successful';
export const FetchCoachesFilterSuccess = createAction(FETCH_COACHES_FILTER_SUCCESS, props<{
  coachesFilter: Filter,
  message: string
}>());

const FETCH_COACHES_FILTER_FAILURE = '[sessions list] fetch coaches filter failure';
export const FetchCoachesFilterFailure = createAction(FETCH_COACHES_FILTER_FAILURE);

/*********** FETCH SESSIONS LIST **************/
const FETCH_SESSIONS_LIST_REQUEST = '[sessions list] fetch sessions list requested';
export const FetchSessionListRequest = createAction(FETCH_SESSIONS_LIST_REQUEST, props<{
  payload: FetchSessionListModel['request']
}>());

const FETCH_SESSIONS_LIST_SUCCESS = '[sessions list] fetch sessions list successful';
export const FetchSessionListSuccess = createAction(FETCH_SESSIONS_LIST_SUCCESS, props<{
  sessionList: FetchSessionListModel['response'],
  message: string
}>());

const FETCH_SESSIONS_LIST_FAILURE = '[sessions list] fetch sessions list failure';
export const FetchSessionListFailure = createAction(FETCH_SESSIONS_LIST_FAILURE);

/*********** FETCH PARTICIPANT ATTENDANCE **************/
const FETCH_PARTICIPANT_ATTENDANCE_REQUEST = '[sessions list] fetch participant attendance requested';
export const FetchParticipantAttendanceRequest = createAction(FETCH_PARTICIPANT_ATTENDANCE_REQUEST, props<{
  payload: FetchParticipantAttendanceModel['request']
}>());

const FETCH_PARTICIPANT_ATTENDANCE_SUCCESS = '[sessions list] fetch participant attendance successful';
export const FetchParticipantAttendanceSuccess = createAction(FETCH_PARTICIPANT_ATTENDANCE_SUCCESS, props<{
  participantAttendanceInfo: FetchParticipantAttendanceModel['response'],
  message: string
}>());

const FETCH_PARTICIPANT_ATTENDANCE_FAILURE = '[sessions list] fetch participant attendance failure';
export const FetchParticipantAttendanceFailure = createAction(FETCH_PARTICIPANT_ATTENDANCE_FAILURE);

/*********** MARK ATTENDANCE **************/
const MARK_ATTENDANCE_REQUEST = '[sessions list] mark attendance requested';
export const MarkAttendanceRequest = createAction(MARK_ATTENDANCE_REQUEST, props<any>());

const MARK_ATTENDANCE_SUCCESS = '[sessions list] mark attendance successful';
export const MarkAttendanceSuccess = createAction(MARK_ATTENDANCE_SUCCESS, props<any>());

const MARK_ATTENDANCE_FAILURE = '[sessions list] mark attendance failure';
export const MarkAttendanceFailure = createAction(MARK_ATTENDANCE_FAILURE);

/*********** MARK DROPOUT **************/
const MARK_PARTICIPANT_DROPOUT_REQUEST = '[sessions list] mark participant  dropout request'
export const MarkParticipantDropoutRequest = createAction(MARK_PARTICIPANT_DROPOUT_REQUEST, props<{
  payload: { userId: any, groupId: any, status: any, sessionId: any }
}>())

const MARK_PARTICIPANT_DROPOUT_SUCCESS = '[sessions list] mark participant  dropout success'
export const MarkParticipantDropoutSuccess = createAction(MARK_PARTICIPANT_DROPOUT_SUCCESS, props<{ payload: { groupId: any, sessionId: any } }>())


const MARK_PARTICIPANT_DROPOUT_FAILURE = '[sessions list] mark participant  dropout failure'
export const MarkParticipantDropoutFailure = createAction(MARK_PARTICIPANT_DROPOUT_FAILURE,)


const DOWNLOAD_VISIT_NOTES_REPORT_REQUEST = '[sessions list] download visit notes report request'
export const DownloadVisitNotesReportRequest = createAction(DOWNLOAD_VISIT_NOTES_REPORT_REQUEST, props<{
  payload: {
    sessionId: string, groupId: string, forUserId: string
  }
}>())

const DOWNLOAD_VISIT_NOTES_REPORT_SUCCESS = '[sessions list] download visit notes report success'
export const DownloadVisitNotesReportSuccess = createAction(DOWNLOAD_VISIT_NOTES_REPORT_SUCCESS)

const DOWNLOAD_VISIT_NOTES_REPORT_FAILURE = '[sessions list] download visit notes report failure'
export const DownloadVisitNotesReportFailure = createAction(DOWNLOAD_VISIT_NOTES_REPORT_FAILURE)
